/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 根据账单号获取订单信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class OrderInfoParams {
  constructor(public billNo?: string) {}
}

export default async function (
  params: OrderInfoParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: payment.OrderInfo;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/payment/order-info`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
